// Library Methods
import i18next from "i18next";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import { PlusIcon } from "src/assets/icons";

import patientHeaderImg from "src/assets/images/operating-manual/instructions-for-use/patient-header.png";
import patientHeaderFrImg from "src/assets/images/operating-manual/instructions-for-use/patient-header-fr.png";
import progressionTabImg from "src/assets/images/operating-manual/instructions-for-use/progression-tab.png";
import progressionTabFrImg from "src/assets/images/operating-manual/instructions-for-use/progression-tab-fr.png";
import progressionCardsImg from "src/assets/images/operating-manual/instructions-for-use/progression-cards.png";
import progressionCardsFrImg from "src/assets/images/operating-manual/instructions-for-use/progression-cards-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

// Styles
import { ModalCustomConfirm } from "src/styles/mui/muiStylesHelper";
import { UI_SIZES } from "src/constants/uiTokens";

const ProgressionAnalysis = () => {
  const { t } = useTranslation("operating-manual");

  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}
    >
      <Typography>
        {t(
          "Once at least three 24-2, 24-2C, or 30-2 exams have been administered, a progression analysis report can be generated."
        )}
      </Typography>

      <Grid container spacing="20px">
        <Grid item xs={12} sm={6}>
          <Typography>
            1.{" "}
            {t(
              "Go to the patient you would like to generate a progression analysis report for, and click the progression analysis tab."
            )}
          </Typography>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={currentLang === "fr" ? patientHeaderFrImg : patientHeaderImg}
              width="100%"
              alt="patient-header"
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mt: "20px",
            }}
          >
            <img
              src={
                currentLang === "fr" ? progressionTabFrImg : progressionTabImg
              }
              width="60%"
              alt="progression-tab"
            />
          </Box>
        </Grid>
      </Grid>

      <Grid container spacing="20px">
        <Grid item xs={12} sm={6}>
          <Typography>
            2. {t("Click the ")}
            <IconButton
              sx={{
                width: `${UI_SIZES.iconButtonSize}px`,
                height: `${UI_SIZES.iconButtonSize}px`,
                color: "#FFF",
                backgroundColor: "#202338",
                borderRadius: "4px",
                pointerEvents: "none",
              }}
            >
              <PlusIcon />
            </IconButton>
            {t(" Add button.")}
          </Typography>
          <Typography mt="20px">
            3.{" "}
            {t(
              "Select the eye and exams you would like to generate progression analysis for."
            )}
          </Typography>

          <Box
            sx={{
              mt: "20px",
            }}
          >
            <Typography>
              4. {t("Click the Generate button:")}{" "}
              <Button
                sx={{
                  ...ModalCustomConfirm(),
                  pointerEvents: "none",
                }}
              >
                {t("Generate")}
              </Button>
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src={
                currentLang === "fr"
                  ? progressionCardsFrImg
                  : progressionCardsImg
              }
              width="100%"
              alt="progression-cards"
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default ProgressionAnalysis;
